import React, { Component } from 'react';
import CardView from './CardsView';
import crmservices from '../../wsclient/crmservices'
import AddCard from './AddCard';
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';

class Cards extends Component {
    constructor(props){
        super(props)
        this.state = {
            initLoad: true,
            cards: {}, 
            openAddCard: false,
            message: {},
        }
        this.onOpenAddCard = this.onOpenAddCard.bind(this)
        this.onCloseAddCard = this.onCloseAddCard.bind(this)
        this.showMessage = this.showMessage.bind(this);
        this.setPrimaryCard = this.setPrimaryCard.bind(this)
        this.onRemoveCard = this.onRemoveCard.bind(this)
    }
    UNSAFE_componentWillMount(){
        this.onLoadPaymentMethods()
    }
    async onLoadPaymentMethods(isRefresh) {
        this.setState({ showLoading: true });
        try {
            var result = await crmservices.contacts.getListPaymentMethods();
            //console.log("onLoadPaymentMethods result==", result);
            if (result.code == 'OK') {
                this.setState({cards:result.data.content});
            }
        } catch (error) {
            console.log("on load payment method exception:", error);
        }
        this.setState({ showLoading: false});
    }
    async setPrimaryCard(paymentMethodID) {
        this.setState({ showLoading: true });
        try {
            var result = await crmservices.contacts.setPrimaryCard(paymentMethodID);
            if (result.code == 'OK') {
                this.showMessage(true, t('You have successfully set this card as primary'));
            } else {
                this.showMessage(true, t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            this.showMessage(true, t('EXCEPTION_PROCESS'));
        }
        this.setState({ showLoading: false });
    }
    async onRemoveCard(card) {
        this.setState({ showLoading: true });
        try {
            var result = await crmservices.contacts.removePaymentMethod(card.id);
            //console.log(' onRemoveCard card==', card)
            if (result.code == 'OK') {
                await this.onLoadPaymentMethods();
                this.showMessage(true, t('REMOVE_CARD_SUCCESS'));
            } else {
                this.showMessage(true, t('FAILED_TO_REMOVE_CARD'));
            }
        } catch (ex) {
            console.log("remove card exception:", ex);
            this.showMessage(true, t('EXCEPTION_PROCESS'));
        }
        this.setState({ showLoading: false });
    }

    async onOpenAddCard() {
        this.setState({ openAddCard: true  });
    }
    onCloseAddCard(){
        this.onLoadPaymentMethods();
        this.setState({openAddCard: false})
    }
    showMessage(status, message) {
        this.setState({
            showLoading: false,
            message: {
                show: status,
                content: message ? message : null
            }
        })
    }
    render() {
        return (
            <div>
                <CardView
                    open = {this.props.open}
                    onCloseItem = {this.props.onCloseItem}
                    showLoading = {this.state.showLoading} 
                    cards = {this.state.cards}
                    onOpenAddCard = {this.onOpenAddCard}
                    setPrimaryCard = {this.setPrimaryCard}
                    onRemoveCard = {this.onRemoveCard}/>
                {this.state.openAddCard && <AddCard
                    open = {this.state.openAddCard}
                    onClose = {this.onCloseAddCard} 
                />}
                {this.state.message && <ModalAlert
                    open={this.state.message.show}
                    onClose={this.showMessage}
                    message={this.state.message.content}
                />}
            </div>
        );
    }
}

export default Cards;